import React from 'react';
import PropTypes from 'prop-types';

import GuardedCheckbox from './GuardedCheckbox';
import ManagementRoleCell from './ManagementRoleCell';
import { AccountCell, ControlCell, ControlSlot, DataRow } from './styles';

/**
 * One account's row. Deliberately dumb: every rule has already been resolved by
 * useAccessPermissionsForm and arrives on the cell as `disabled` and
 * `lockReason`. This renders a cell by its type and reports the change.
 */
function MatrixRow({ cells, name, onCellChange, rowId, stripe }) {
  const dividerKey = cells.find((cell) => cell.type === 'discoverability')?.key;

  return (
    <DataRow $stripe={stripe}>
      <AccountCell scope="row">{name}</AccountCell>

      {cells.map((cell) => (
        <ControlCell key={cell.key} $bandStart={cell.key === dividerKey}>
          <ControlSlot>
            {cell.type === 'tier' ? (
              <ManagementRoleCell
                disabled={cell.disabled}
                label={cell.label}
                lockReason={cell.lockReason}
                onSelect={(roleId) => onCellChange(rowId, cell.key, roleId)}
                options={cell.options}
                value={cell.value}
              />
            ) : (
              <GuardedCheckbox
                checked={cell.checked}
                disabled={cell.disabled}
                label={cell.label}
                lockReason={cell.lockReason}
                onChange={(next) => onCellChange(rowId, cell.key, next)}
              />
            )}
          </ControlSlot>
        </ControlCell>
      ))}
    </DataRow>
  );
}

export const MATRIX_CELL = PropTypes.shape({
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  key: PropTypes.string,
  label: PropTypes.string,
  lockReason: PropTypes.string,
  options: PropTypes.array,
  type: PropTypes.string,
  value: PropTypes.object,
});

MatrixRow.propTypes = {
  cells: PropTypes.arrayOf(MATRIX_CELL).isRequired,
  name: PropTypes.string.isRequired,
  onCellChange: PropTypes.func.isRequired,
  /** The account id, or 'all' for the Apply-to-All row. */
  rowId: PropTypes.string.isRequired,
  /** Whether this row takes the zebra fill; set by position within its team. */
  stripe: PropTypes.bool,
};

MatrixRow.defaultProps = {
  stripe: false,
};

export default MatrixRow;
